import { Box, Modal } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close';
import React from 'react'

const ComingSoonModal = ({ copyRightOpen, setCopyRightOpen }) => {

    const handleNewClose = () => {


        setCopyRightOpen(false)
    }
    return (
        <>
            <Modal
                open={copyRightOpen}
                onClose={handleNewClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                className="banner_modal_main"
            >
                <Box className="banner_modal_box_new">
                    <div
                        id="modal-modal-description"

                        className="modal_banner_new"
                    >
                        <div className="sub_modal_banner">
                            <span className="close_btn" onClick={handleNewClose}>
                                <CloseIcon />
                            </span>
                            <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/assets/images/logobanner.webp" alt="bannerLogo" />
                            <p class="modal_commingsoon">Coming soon</p>

                        </div>
                    </div>
                </Box>
            </Modal>
        </>
    )
}

export default ComingSoonModal